<template>
  <div class="bbe-list" :class="{'bbe-list_background': !activeThread}">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bbe-list-header">
      <div class="bbe-list-header-checked" @click="selectAllMails">
        <checkbox :value="checkedMails.length > 0 && checkedMails.length === listEmails.length"
                  @checkboxChange="selectAllMails"/>
        <span class="bbe-list-header-checked__count">
          All select
          <span class="bbe-list-header-checked__length">({{list.length}})</span>
        </span>
      </div>
      <transition name="bbe-fade-options">
        <div class="bbe-list-header-sort"
             v-if="unreadDisplay.includes(customType)"
             @click="unreadMailsSort = !unreadMailsSort">
          <span class="bbe-list-header-sort__text">Unread</span>
          <i class="email-icon-up-arrow bbe-list-header-sort__icon"
             :class="{'bbe-list-header-sort__icon_active': unreadMailsSort}"/>
        </div>
      </transition>
    </div>
    <div>
      <div
        class="bbe-list-body"
        :class="{'bbe-list-body_hide': hideBody}"
        :settings="{minScrollbarLength: 25}"
        ref="bbeInboxScroll"
      >
        <!--      @resize="setContainerHeight"-->
        <!--      @ps-scroll-y="calcPositionThrottle"-->
        <div
          class="bbe-list-body__shadow"
          :class="{'bbe-list-body__shadow_radius': activeThreadIndex === 0}"
        />
        <transition name="bbe-bounce">
          <span
            v-if="gmailApi.error"
            class="bbe-label__error bbe-list-body__error"
          >
            {{gmailApi.error}}
          </span>
        </transition>
          <!--          v-if="thread.id &&-->
          <!--          thread.emailTitle &&-->
          <!--          index + backlash >= hideIndex &&-->
          <!--          index - backlash <= hideIndex + countDisplayThreads"-->
        <VirtualList
          class="bbe-list-body-virtual"
          ref="bbeThread"
          :data-key="'id'"
          :data-sources="list"
          :keeps="10"
          :extra-props="{
            optionAction,
            activeThreadIndex,
            activeThread,
            checkedMails,
            customType,
            mailChecked,
          }"
          :data-component="emailListCard"
          :option-action="optionAction"
          :active-thread-index="activeThreadIndex"
          :active-thread="activeThread"
          :checked-mails="checkedMails"
          :custom-type="customType"
          @mailChecked="mailChecked"
          v-on:tobottom="onScrollToBottom"
          @scroll="onScroll"
        />
        <div
          v-if="listEmails.length > 0"
          class="bbe-list-body__end-list"
        />
      </div>
    </div>
    <i
      v-show="!newMessage.openFullSize"
      class="email-icon-plus bbe-button-new-message"
      ref="bbeButtonAdd"
      @click="createNewMessage()"
    />
  </div>
</template>

<script>
import {
  cloneDeep,
  compact,
  filter,
  find,
  findIndex,
  get,
  includes,
  isEmpty,
  throttle,
  uniqBy,
  orderBy,
  set,
  // chunk,
  trim
} from 'lodash'
import MailTrackerIndicator from '@/components/Main/MailTracker/MailTrackerIndicator'
import checkbox from '@/components/Main/FormsElements/checkbox'
import defaultAvatar from '@/assets/images/user.png'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import getInfoFromThread from '@/mixin/getInfoFromThread'
import changeMailsStore from '@/mixin/changeMailsStore'
import allAddresses from '@/mixin/allAddresses'
import setUserInfo from '@/mixin/setUserInfo'
import signatureGenerator from '@/mixin/signatureGenerator'
import signatureGeneratorType2 from '@/mixin/signatureGeneratorType2'
import generateBodyForward from '@/mixin/generateBodyForward'
import routerPush from '@/mixin/routerPush'
import getContactsListFromCRM from '@/mixin/getContactsListFromCRM'
import userEmailsApi from '@/api/UserEmails/api'
import GmailApi from '@/api/Gmail/api'
import {dragscroll} from 'vue-dragscroll'
import moment from 'moment'
import emailTrackerApi from '@/api/EmailTracker/api'
import checkUserEmail from '@/mixin/checkUserEmail'
import EmailListCard from '@/components/Email/EmailList/EmailListCard/EmailListCard'
import timeout from '@/mixin/timeout'
import resetEmailsStore from '@/mixin/resetEmailsStore'
import headerGmail from '@/mixin/headerGmail'
import {sidebarTabs, SENT, DRAFT, INBOX, TRASH} from '@/constants/sidebarTabs'
import VirtualList from 'vue-virtual-scroll-list'

export default {
  name: 'EmailList',
  props: ['type', 'filterByTag'],
  directives: {
    dragscroll
  },
  mixins: [
    headerGmail,
    getInfoFromThread,
    changeMailsStore,
    setUserInfo,
    signatureGenerator,
    signatureGeneratorType2,
    generateBodyForward,
    routerPush,
    getContactsListFromCRM,
    checkUserEmail,
    timeout,
    resetEmailsStore,
    allAddresses
  ],
  components: {
    EmailListCard,
    checkbox,
    VuePerfectScrollbar,
    LoaderFly,
    MailTrackerIndicator,
    VirtualList
  },
  sockets: {
    newMessage ({_doc}) {
      const userIdNotification = get(_doc, 'user', '')
      const currentUserId = get(this.activeUser, 'id', '')
      if (userIdNotification !== currentUserId) return
      const threadId = get(_doc, 'threadId', '')
      if (!threadId) return
      this.$emit('updateCounter')
      // this.updateThread(threadId)
    }
  },
  data () {
    return {
      emailListCard: EmailListCard,
      searchInGmail: false,
      searchPageToken: '',
      searchList: [],
      backlash: 10,
      hideIndex: 0,
      threadHeight: 158,
      containerHeight: 0,
      unreadMailsSort: false,
      checkboxHover: false,
      checkedMails: [],
      defaultAvatar: defaultAvatar,
      visibleOptions: false,
      oldVisibleOptions: false,
      activeThread: false,
      activeThreadIndex: false,
      loaderRun: false,
      loaderNextPage: false,
      hideBody: false,
      threadIdsFromHistory: [],
      filteredList: [],
      ackIds: [],
      typeCases: {},
      unreadDisplay: ['INBOX', 'TODO', 'SAVED'],
      optionAction: {
        toTrash: this.toTrash,
        modifyLabels: this.modifyLabels,
        batchModify: this.batchModify,
        openForwardMessage: this.openForwardMessage,
        deleteThread: this.deleteThread,
        batchDelete: this.batchDelete,
        setThread: this.setThread
      },
      emailPull: false,
      bbeThread: null
    }
  },
  computed: {
    countNodes () {
      return this.list.filter((thread, index) => {
        return thread.id &&
          thread.emailTitle &&
          index + this.backlash >= this.hideIndex &&
          index - this.backlash <= this.hideIndex + this.countDisplayThreads
      }) || []
    },
    countDisplayThreads () {
      return Math.ceil(this.containerHeight / this.threadHeight)
    },
    heightHideNodeTop () {
      const topHideCount = (this.hideIndex + 1 - this.backlash) * this.threadHeight
      const height = topHideCount < 0 ? 0 : topHideCount
      return {
        minHeight: height + 'px',
        height: height + 'px'
      }
    },
    heightHideNodeBot () {
      const count = this.list.length - (this.hideIndex + this.countDisplayThreads + this.backlash)
      const botHideCount = count * this.threadHeight
      const height = botHideCount < 0 ? 0 : botHideCount
      return {
        minHeight: height + 'px',
        height: height + 'px'
      }
    },
    userId () {
      return get(this.activeUser, 'gmail.email', 'me')
    },
    customType () {
      const tab = find(sidebarTabs, {id: this.type})
      const id = get(tab, 'id', '')
      return get(tab, 'systemId', id)
    },
    configApiKeys () {
      return this.$store.getters.configApiKeys
    },
    projectId () {
      return this.configApiKeys.projectId
    },
    subscriptionId () {
      return this.configApiKeys.subscriptionId
    },
    topicId () {
      return this.configApiKeys.topicId
    },
    contactsList: {
      get () {
        return this.$store.getters.contactsListMail
      },
      set (data) {
        this.$store.dispatch('setContactListMail', data)
      }
    },
    activeTab: {
      get: function () {
        return this.$store.getters.activeTab
      },
      set: function (data) {
        this.$store.dispatch('setActiveTab', data)
      }
    },
    searchStore () {
      return this.$store.getters.search
    },
    gmailApi: {
      get () {
        return this.$store.getters.gapi || this.$store.getters.gmailApi
      },
      set (data) {
        if (this.$store.getters.gapi) {
          this.$store.dispatch('setGapi', data)
        } else {
          this.$store.dispatch('setGmailApi', data)
        }
      }
    },
    newMessage: {
      get () {
        return this.$store.getters.newMessage
      },
      set (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    activeEmail: {
      get () {
        return this.$store.getters.activeEmail
      },
      set (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    activeUser: {
      get () {
        return this.$store.getters.userInfo || this.$store.getters.activeUser
      },
      set (data) {
        if (this.$store.getters.userInfo) {
          this.$store.dispatch('setUserInfo', data)
        } else {
          this.$store.dispatch('setActiveUser', data)
        }
      }
    },
    userInfo: {
      get () {
        return this.$store.getters.userInfo
      },
      set (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    updateThreadStore: {
      get () {
        return this.$store.getters.updateThreadStore
      },
      set (data) {
        this.$store.dispatch('setUpdateThreadStore', data)
      }
    },
    trashEmail: {
      get () {
        return this.$store.getters.trashEmail
      },
      set (data) {
        this.$store.dispatch('setTrashEmail', data)
      }
    },
    sentEmail: {
      get () {
        return this.$store.getters.sentEmail
      },
      set (data) {
        this.$store.dispatch('setSentEmail', data)
      }
    },
    draftEmail: {
      get () {
        return this.$store.getters.draftEmail
      },
      set (data) {
        this.$store.dispatch('setDraftEmail', data)
      }
    },
    inboxEmail: {
      get () {
        return this.$store.getters.inboxEmail
      },
      set (data) {
        this.$store.dispatch('setInboxEmail', data)
      }
    },
    todoEmail: {
      get () {
        return this.$store.getters.todoEmail
      },
      set (data) {
        this.$store.dispatch('setTodoEmail', data)
      }
    },
    savedEmail: {
      get () {
        return this.$store.getters.savedEmail
      },
      set (data) {
        this.$store.dispatch('setSavedEmail', data)
      }
    },
    listEmails: {
      get () {
        if (this.searchInGmail) return this.searchList
        switch (this.type) {
        case 'SENT':
          return this.$store.getters.sentEmail
        case 'TRASH':
          return this.$store.getters.trashEmail
        case 'DRAFT':
          return this.$store.getters.draftEmail
        case this.typeCases.SAVED:
          return this.$store.getters.savedEmail
        case this.typeCases.TODO:
          return this.$store.getters.todoEmail
        default:
          return this.$store.getters.inboxEmail
        }
      },
      set (data) {
        if (this.searchInGmail) {
          this.searchList = data
          return
        }
        switch (this.type) {
        case 'SENT':
          this.$store.dispatch('setSentEmail', data)
          break
        case 'TRASH':
          this.$store.dispatch('setTrashEmail', data)
          break
        case 'DRAFT':
          this.$store.dispatch('setDraftEmail', data)
          break
        case this.typeCases.SAVED:
          this.$store.dispatch('setSavedEmail', data)
          break
        case this.typeCases.TODO:
          this.$store.dispatch('setTodoEmail', data)
          break
        default:
          this.$store.dispatch('setInboxEmail', data)
        }
      }
    },
    list () {
      const list = this.searchInGmail ? this.searchList : this.listEmails
      const uniqThread = uniqBy(list, 'id')
      const result = this.filterByTag.id ? this.filteredList : uniqThread
      const sortedByDate = orderBy(compact(result), thread => new Date(thread.date), ['desc'])
      const setDateFormat = sortedByDate.map(thread => {
        thread.dateFormat = this.getDateFormat(thread)
        return thread
      })
      return this.hideBody ? [] : setDateFormat
    },
    listSortedByUnread () {
      return orderBy(this.list, ['unread'], ['desc'])
    },
    nextPageToken: {
      get () {
        if (this.searchInGmail) return this.searchPageToken
        switch (this.type) {
        case 'SENT':
          return this.$store.getters.sentPageToken
        case 'TRASH':
          return this.$store.getters.trashPageToken
        case 'DRAFT':
          return this.$store.getters.draftPageToken
        case this.typeCases.SAVED:
          return this.$store.getters.savedPageToken
        case this.typeCases.TODO:
          return this.$store.getters.todoPageToken
        default:
          return this.$store.getters.inboxPageToken
        }
      },
      set (data) {
        if (this.searchInGmail) {
          this.searchPageToken = data
          return
        }
        switch (this.type) {
        case 'SENT':
          this.$store.dispatch('setSentPageToken', data)
          break
        case 'TRASH':
          this.$store.dispatch('setTrashPageToken', data)
          break
        case 'DRAFT':
          this.$store.dispatch('setDraftPageToken', data)
          break
        case this.typeCases.SAVED:
          this.$store.dispatch('setSavedPageToken', data)
          break
        case this.typeCases.TODO:
          this.$store.dispatch('setTodoPageToken', data)
          break
        default:
          this.$store.dispatch('setInboxPageToken', data)
        }
      }
    },
    calcPositionThrottle () {
      return throttle(this.calcPosition, 250)
    }
  },
  methods: {
    async updateThread (threadId) {
      const thread = await this.getThread(threadId)
      const labelIds = get(thread, 'labelIds', [])
      labelIds.forEach(type => {
        const store = this.getStoreEmail(type)
        if (!store.length) return
        const index = findIndex(store, {id: threadId})
        index !== -1 ? store.splice(index, 1) : store.unshift(thread)
      })
      return thread
    },
    checkedDeletedThread (threadId) {
      if (this.activeEmail.id === threadId) {
        this.activeEmail = {}
      }
    },
    // getContacts () {
    //   this.getContactsListFromCRM(this.contactsList)
    //   this.$gapi.request({
    //     path: 'https://people.googleapis.com/v1/people/me/connections',
    //     method: 'GET',
    //     params: {
    //       personFields: 'names,emailAddresses'
    //     }
    //   })
    //     .then(resp => {
    //       if (resp.result.totalPeople === 0) return
    //       resp.result.connections.map(people => {
    //         const peopleReady = {
    //           email: '',
    //           name: ''
    //         }
    //         if (people.emailAddresses) peopleReady.email = people.emailAddresses[0].value
    //         if (people.names) peopleReady.name = people.names[0].displayName
    //         try {
    //           this.contactsList.push(peopleReady)
    //         } catch (e) {
    //           console.warn(e)
    //         }
    //       })
    //     })
    //     .catch(err => {
    //       console.warn(err)
    //     })
    // },
    openForwardMessage ({threadId}) {
      this.createBodyForward()
      // const thread = find(this.listEmails, {id: threadId})
      // const body = this.generateBodyForward(thread)
      // const files = body.attachments.map(item => {
      //   item.status = true
      //   return item
      // })
      // this.activeEmail = {}
      // this.newMessage = {
      //   open: false,
      //   subject: body.subject,
      //   contents: body.contentsHTML,
      //   files: files,
      //   openFullSize: true
      // }
      if (this.$route.name !== 'MainPageEmail') {
        const tabName = this.activeTab.toLowerCase()
        this.routerPush({name: 'TabOpen', params: {tab: tabName}})
      }
    },
    // checkUpdateThread (query) {
    //   this.$gapi.request({
    //     path: `https://www.googleapis.com/gmail/v1/users/${this.userId}/threads`,
    //     params: {
    //       labelIds: this.type || 'INBOX',
    //       maxResults: 10,
    //       q: query ? `{${query}}` : ''
    //     },
    //     method: 'GET'
    //   })
    //     .then(async response => {
    //       if (!response.result.resultSizeEstimate) return
    //       const promisesThreads = response.result.threads.map(async item => {
    //         const index = findIndex(this.listEmails, {id: item.id})
    //         if (index !== -1) return
    //         item = await this.getThread(item.id)
    //         return item
    //       })
    //       const threads = await Promise.all(promisesThreads)
    //       threads.forEach(thread => {
    //         if (!thread) return
    //         const index = findIndex(this.listEmails, {id: thread.id})
    //         if (index === -1) this.listEmails.unshift(thread)
    //       })
    //     })
    //     .catch(err => {
    //       console.error(err)
    //     })
    // },
    // getThreadsList ({userId, pageToken, limit, label}) {
    //   return
    //   const query = this.searchInGmail
    //   pageToken ? this.loaderNextPage = true : this.loaderRun = true
    //   const params = {
    //     labelIds: [this.type || 'INBOX'],
    //     maxResults: limit || 50
    //   }
    //   if (this.unreadMailsSort) params.labelIds.push('UNREAD')
    //   if (pageToken) params.pageToken = pageToken
    //   if (query) {
    //     params.q = `{${query}}`
    //   }
    //   this.$gapi.request({
    //     path: `https://www.googleapis.com/gmail/v1/users/${userId}/threads`,
    //     params: params,
    //     method: 'GET'
    //   })
    //     .then(response => {
    //       if (!pageToken) this.scrollUp()
    //       this.nextPageToken = get(response, 'result.nextPageToken', '')
    //       if (!response.result.resultSizeEstimate) {
    //         this.loaderRun = false
    //         this.loaderNextPage = false
    //         this.listEmails = []
    //         return
    //       }
    //       const responseSize = response.result.threads.length
    //       const paramsFullList = {
    //         list: response.result.threads,
    //         limit: limit || params.maxResults,
    //         userId,
    //         responseSize,
    //         pageToken,
    //         label,
    //         query
    //       }
    //       this.getThreadFullListAsync(paramsFullList)
    //     })
    //     .catch(err => {
    //       this.loaderRun = false
    //       this.loaderNextPage = false
    //       console.error(err)
    //     })
    // },
    // async getThreadFullList ({list, userId, responseSize, query, label}) {
    //   const promisesThreads = list.map(async item => {
    //     item = await this.getThread(item.id)
    //     return item
    //   })
    //   try {
    //     return await Promise.all(promisesThreads)
    //   } catch (err) {
    //     console.error(err)
    //   }
    // },
    // async getThreadFullListAsync ({list, userId, responseSize, pageToken, label, query, limit}) {
    //   const chunks = chunk(list, limit)
    //   for await (let listChunk of chunks) {
    //     const result = await this.getThreadFullList({list: listChunk, userId, responseSize, pageToken, label, query})
    //     if ((this.searchInGmail || query) && this.searchInGmail !== query) return
    //     const listEmails = uniqBy(this.getStoreEmail(label).concat(result), 'id')
    //     this.setStoreEmail(label, listEmails)
    //     await this.timeout(1000)
    //   }
    //   this.loaderRun = false
    //   this.loaderNextPage = false
    //   if (!query) this.runBackgroundLoadingThreads({label, query})
    // },
    getStoreEmail (type) {
      if (this.searchInGmail) return this.searchList
      switch (type) {
      case 'SENT':
        return this.sentEmail
      case 'TRASH':
        return this.trashEmail
      case 'DRAFT':
        return this.draftEmail
      case this.typeCases.SAVED:
        return this.savedEmail
      case this.typeCases.TODO:
        return this.todoEmail
      default:
        return this.inboxEmail
      }
    },
    setStoreEmail (type, data) {
      if (this.searchInGmail) {
        this.searchList = data
        return
      }
      switch (type) {
      case 'SENT':
        this.sentEmail = data
        break
      case 'TRASH':
        this.trashEmail = data
        break
      case 'DRAFT':
        this.draftEmail = data
        break
      case this.typeCases.SAVED:
        this.savedEmail = data
        break
      case this.typeCases.TODO:
        this.todoEmail = data
        break
      default:
        this.inboxEmail = data
      }
    },
    // runBackgroundLoadingThreads ({label, query}) {
    //   const changeLabel = this.type !== label && label
    //   const limitExceeded = this.listEmails.length >= 500
    //   if (!this.nextPageToken || this.loaderNextPage || limitExceeded || changeLabel) return
    //   this.getThreadsList({
    //     limit: 100,
    //     userId: this.userId,
    //     pageToken: this.nextPageToken,
    //     label: this.type,
    //     query
    //   })
    // },
    setInfoEveryMessage () {
      this.listEmails.forEach((thread) => {
        if (!Array.isArray(thread.messages)) return
        thread.messages.map((msg, index) => {
          msg.info = this.getInfoMail(thread, index)
          try {
            this.contactsList.push(msg.info.from)
          } catch (e) {
            console.warn(e)
          }
        })
      })
    },
    // async getThread (threadId) {
    //   try {
    //     const resp = await this.$gapi.request({
    //       path: `https://www.googleapis.com/gmail/v1/users/${this.userId}/threads/${threadId}`,
    //       method: 'GET'
    //     })
    //     const {tags, idUserMail} = await this.getTags(threadId)
    //     const messages = resp.result.messages.reverse()
    //     messages.map((msg, index) => {
    //       msg.info = this.getInfoMail(resp.result, index)
    //       try {
    //         this.contactsList.push(msg.info.from)
    //       } catch (e) {
    //         console.warn(e)
    //       }
    //     })
    //     const fullInfo = {...resp.result, ...this.getInfoMail(resp.result)}
    //     fullInfo.tracking = this.activeTab === 'SENT' ? await this.getTrackers({threadId, userId: this.userId}) : []
    //     fullInfo.tags = tags
    //     fullInfo.idUserMail = idUserMail
    //     fullInfo.emailTitle = this.getNameMail(fullInfo)
    //     const includesTab = fullInfo.labelIds.includes(this.activeTab)
    //     const index = findIndex(this.listEmails, {id: threadId})
    //     if (index !== -1) {
    //       includesTab ? this.$set(this.listEmails, index, fullInfo) : this.listEmails.splice(index, 1)
    //     } else {
    //       return fullInfo
    //     }
    //     this.setInfoEveryMessage()
    //     return fullInfo
    //   } catch (e) {
    //     console.error(e)
    //     return {}
    //   }
    // },
    deleteUserMail (threadId) {
      const targetMail = find(this.listEmails, {id: threadId})
      const userEmailId = get(targetMail, 'idUserMail', '')
      if (!userEmailId) return
      userEmailsApi.deleteUserEmails(userEmailId)
    },
    batchDelete ({userId, ids}) {
      const body = {
        ids: ids
      }
      this.moveThreads('deleteForever', this.checkedMails)
      this.$gapi.request({
        path: `https://www.googleapis.com/gmail/v1/users/${userId}/messages/batchDelete`,
        method: 'POST',
        body: body
      })
        .then(resp => {
          this.$emit('updateCounter')
          this.calcPositionThrottle()
          this.checkedMails = []
          // this.getThreadsList({userId: this.userId, pageToken: this.nextPageToken, label: this.type})
        })
        .catch(err => {
          console.error(err)
        })
    },
    removeActiveThread (ids) {
      const noThread = !ids || !ids.includes(this.activeThread.id)
      if (noThread) {
        this.activeEmail = {}
        this.activeThread = false
        this.activeThreadIndex = false
      } else {
        return
      }
      if (this.$route.name !== 'MainPageEmail') {
        const tabName = this.activeTab.toLowerCase()
        this.routerPush({name: 'TabOpen', params: {tab: tabName}})
      }
    },
    moveThreads (type, idsThreads) {
      const moveFromTrash = type === 'fromTrash'
      const deleteForever = type === 'deleteForever'
      const deleteDraft = type === 'deleteDraft'
      idsThreads.forEach(idThread => {
        if (moveFromTrash) {
          const email = this.spliceThread(idThread, this.trashEmail)
          const messages = get(email, 'messages', [])
          const labelsSent = messages.map(message => includes(message.labelIds, 'SENT'))
          const pushToSent = labelsSent.some(item => item)
          this.pushThread(email, this.inboxEmail, true)
          this.pushThread(email, this.sentEmail, pushToSent)
        } else if (deleteForever) {
          this.spliceThread(idThread, this.trashEmail)
        } else if (deleteDraft) {
          this.spliceThread(idThread, this.draftEmail)
        } else {
          this.removeActiveThread(idsThreads)
          const email = this.spliceThread(idThread, this.inboxEmail)
          this.spliceThread(idThread, this.sentEmail)
          this.pushThread(email, this.trashEmail, true)
        }
        this.checkedDeletedThread(idThread)
      })
      if (!this.listEmails.length) {
        setTimeout(() => {
          this.$emit('resetActiveTab')
        }, 500)
      }
    },
    clickOption (option, thread, unread) {
      option.action({
        userId: this.userId,
        threadId: thread.id,
        type: unread ? option.type : (option.typeAlt || option.type)
      })
    },
    clickHeaderOption (option) {
      const idsMessages = []
      this.checkedMails.forEach(threadId => {
        const thread = find(this.listEmails, {id: threadId})
        if (thread) {
          thread.messages.forEach(message => {
            idsMessages.push(message.id)
          })
        }
      })
      const params = {
        userId: this.userId,
        ids: idsMessages,
        type: option.type
      }
      option.actionHeader(params)
    },
    getIcon (option, thread) {
      const hover = option.hover && this.visibleOptions === thread.id
      const unread = thread.unread || option.type !== 'removeUnread'
      const icon = unread ? option.icon : option.iconAlt
      const iconActive = unread ? option.iconActive : option.iconActiveAlt
      return hover ? iconActive : icon
    },
    getTitleTooltip (option, thread) {
      const unread = thread.unread || option.type !== 'removeUnread'
      return unread ? option.tooltip : option.tooltipAlt
    },
    getDateFormat (thread) {
      const date = get(thread, 'date', '')
      const momentDate = moment(date)
      const isValid = momentDate.isValid()
      if (!isValid) return ''
      const dur = moment.duration({ from: new Date(), to: date })
      const days = Math.ceil(dur.asDays())
      const relativeDate = momentDate.fromNow()
      const justNow = /second/gi.test(relativeDate)
      if (days <= -2) {
        return momentDate.format('DD-MMM-YY')
      } else if (justNow) {
        return 'just now'
      } else {
        return relativeDate
      }
    },
    delHoverThread (id) {
      this.visibleOptions = false
      this.checkboxHover = false
      this.oldVisibleOptions = id
    },
    setHoverThread (id) {
      this.visibleOptions = id
    },
    checkUnread (thread) {
      return thread.unread && this.unreadDisplay.includes(this.customType)
    },
    getNameMail (thread) {
      const fromEmail = get(thread, 'from.email', '')
      const from = get(thread, 'from.name', fromEmail)
      const toEmail = get(thread, 'to.email', '')
      const toName = get(thread, 'to.name', toEmail)
      const copies = get(thread, 'cc', '') || get(thread, 'bcc', '')
      const to = toName || copies
      return this.activeTab === 'SENT' ? to : from
    },
    getValueCheckbox (name) {
      return this.checkedMails.includes(name.id)
    },
    mailChecked (data, name) {
      const id = name.id
      this.visibleOptions = id
      this.oldVisibleOptions = id
      const index = this.checkedMails.indexOf(id)
      if (data) {
        this.checkedMails.push(id)
      } else if (index !== -1) {
        this.checkedMails.splice(index, 1)
      }
    },
    selectAllMails () {
      this.visibleOptions = false
      this.oldVisibleOptions = false
      if (this.checkedMails.length === this.listEmails.length) {
        this.checkedMails = []
      } else {
        const listThreadId = this.listEmails.map(item => item.id)
        this.checkedMails = cloneDeep(listThreadId)
      }
    },
    calcPosition () {
      this.scrollEnd = false
      this.containerHeight = get(this.$refs, 'bbeInboxScroll.ps.containerHeight', 0)
      const scrollTop = get(this.$refs, 'bbeInboxScroll.$el.scrollTop', 0)
      this.hideNodeOutsideScroll(scrollTop)
      if (!this.nextPageToken || this.loaderNextPage) return
      const contentHeight = get(this.$refs, 'bbeInboxScroll.ps.contentHeight', 0)
      const positionScroll = contentHeight - this.containerHeight - scrollTop
      if (positionScroll <= 3000) {
        // this.getThreadsList({userId: this.userId, pageToken: this.nextPageToken, label: this.type})
      }
    },
    hideNodeOutsideScroll (scrollTop) {
      this.hideIndex = Math.floor(scrollTop / this.threadHeight)
    },
    scrollUp () {
      this.hideIndex = 0
      const scroll = get(this.$refs, 'bbeInboxScroll.$el', 0)
      if (!scroll) return
      scroll.scrollTop = 0
    },
    checkActiveThread (setId) {
      const paramMailing = get(this.$route, 'params.massMailing', false)
      if (paramMailing) {
        this.activeEmail = {}
        return
      }
      const idFromActiveEmail = get(this.activeEmail, 'id', 0)
      const idFromRoute = get(this.$route, 'params.id', 0)
      const id = setId || idFromRoute || idFromActiveEmail
      const thread = find(this.listEmails, {id: id})
      if (!id || !thread) {
        this.activeThreadIndex = false
        return
      }
      if (thread.unread) {
        this.modifyLabels({
          userId: this.userId,
          threadId: thread.id,
          type: 'removeUnread'
        })
      }
      const index = findIndex(this.list, {id: id})
      this.setThread(thread, index)
    },
    createNewMessage () {
      this.newMessage = {}
      const params = {
        photo: get(this.activeUser, 'image.path', ''),
        username: get(this.activeUser, 'username', ''),
        position: get(this.activeUser, 'position.name', ''),
        phone: get(this.activeUser, 'phone', ''),
        email: get(this.activeUser, 'email', '')
      }
      const { signatureType = 1 } = this.currentCompany
      this.newMessage.contents = signatureType === 1
        ? this.generateSignature(params)
        : this.generateSignatureType2(params)
      const tabName = this.activeTab.toLowerCase()
      this.routerPush({name: 'TabOpen', params: {tab: tabName}})
      this.$set(this.newMessage, 'openFullSize', true)
      this.$set(this.newMessage, 'isHideMailingList', true)
    },
    async setSentMessageInList () {
      const labelIds = get(this.newMessage, 'send.labelIds', [])
      const threadId = get(this.newMessage, 'send.threadId', '')
      if (!threadId) return
      this.loaderRun = true
      const mail = await this.getThread(threadId)
      labelIds.forEach(label => {
        let store = []
        if (label === 'INBOX') {
          store = this.inboxEmail
        } else if (label === 'SENT') {
          store = this.sentEmail
        } else if (label === 'TRASH') {
          store = this.trashEmail
        }
        const index = findIndex(store, {id: threadId})
        if (index === -1 && store.length > 0) {
          store.unshift(mail)
        } else if (index !== -1 && store.length > 0) {
          this.activeEmail = mail
          this.$set(store, index, mail)
        }
        this.checkActiveThread(threadId)
      })
      this.setInfoEveryMessage()
    },
    signInGmail () {
      this.resetEmailsStore()
      if (typeof this.gmailApi.signIn !== 'function') return
      this.gmailApi.signIn()
        .then(resp => {
          const user = cloneDeep(this.activeUser)
          user.gmail = this.setFullUser(resp)
          this.activeUser = user
          this.gmailApi.error = ''
        })
        .catch(err => {
          const user = cloneDeep(this.activeUser)
          user.gmail = {}
          this.activeUser = user
          this.$set(this.gmailApi, 'error', err.details || err.error)
          console.error('Not signed in: ', err)
        })
    },
    // checkedList (newVal, oldVal) {
    //   this.hideBody = true
    //   this.checkUpdateThread()
    //   setTimeout(() => {
    //     this.hideBody = false
    //     this.checkActiveThread()
    //   }, 400)
    //   if (newVal && newVal !== oldVal && !this.listEmails.length) {
    //     this.getThreadsList({userId: this.userId, label: this.type})
    //     this.activeThreadIndex = false
    //     this.activeThread = false
    //     this.checkedMails = []
    //   }
    // },
    // setTypeCases () {
    //   sidebarTabs.forEach(tab => {
    //     if (tab.systemId) set(this.typeCases, tab.systemId, tab.id)
    //   })
    // },
    getUserEmails ({page, limit}) {
      this.loaderRun = true
      const tagId = get(this.filterByTag, 'id', '')
      userEmailsApi.getUserEmails({page, limit, tags: tagId})
        .then(async resp => {
          const uniqUserMails = uniqBy(resp.data.useremails, 'googleId')
          const responseSize = uniqUserMails.length
          if (!responseSize) this.loaderRun = false
          const alreadyLoaded = []
          uniqUserMails.forEach(userMail => {
            const mail = find(this.listEmails, {id: userMail.googleId})
            mail ? alreadyLoaded.push(mail) : userMail.needLoaded = true
          })
          const mailsWithoutLoaded = filter(uniqUserMails, {needLoaded: true})
          const promisesThreads = mailsWithoutLoaded.map(async item => {
            item = await this.getThread(item.googleId)
            return item
          })
          const result = alreadyLoaded.concat(await Promise.all(promisesThreads))
          this.filteredList = result.filter(item => item.id)
          this.loaderRun = false
        })
        .catch(err => {
          console.error(err)
        })
    },
    async getTrackers ({threadId, userId}) {
      try {
        const resp = await emailTrackerApi.getEmailTracker({threadId, userId})
        return resp.data
      } catch (err) {
        console.error(err)
        return []
      }
    },
    async getTags (threadId) {
      try {
        const resp = await userEmailsApi.getUserEmails({threadId: threadId})
        const tags = resp.data.useremails.reduce((acc, item) => {
          acc = acc.concat(item.tags)
          return acc
        }, [])
        return {
          tags: uniqBy(tags, 'id'),
          idUserMail: get(resp, ['data', 'useremails', 0, 'id'], '')
        }
      } catch (err) {
        console.error(err)
        return {
          tags: [],
          idUserMail: ''
        }
      }
    },
    // async checkOpenThreadFromNotify () {
    //   const threadId = get(this.$route, 'params.openThread', false)
    //   if (!threadId) return
    //   this.loaderRun = true
    //   const thread = await this.updateThread(threadId)
    //   this.loaderRun = false
    //   const indexSent = findIndex(this.sentEmail, {id: threadId})
    //   const indexInbox = findIndex(this.inboxEmail, {id: threadId})
    //   const index = indexSent === -1 ? indexInbox : indexSent
    //   this.setThread(thread, index)
    // },
    setContainerHeight () {
      this.containerHeight = get(this.$refs, 'bbeInboxScroll.ps.containerHeight', 0)
    },
    async deleteThread (item) {
      const {threadId} = item
      this.moveThreads('deleteForever', [threadId])
      const body = this.headerGmail()
      try {
        await GmailApi.deleteForever(threadId, body)
      } catch (err) {
        console.error(err)
      }
    },
    async setThread ({thread, index}) {
      await this.getMessageInfo(thread)
      this.goToRoute(thread, index)
    },
    goToRoute (thread, index) {
      const checkIndex = this.activeThreadIndex !== index || this.activeThreadIndex < 0
      const checkRoute = this.$route.params.id !== thread.id
      if (checkIndex) {
        this.activeEmail = {
          ...this.activeEmail,
          ...thread
        }
        this.newMessage.openFullSize = false
        this.newMessage.openTemplate = false
      }
      if (checkIndex && checkRoute) {
        const tabName = this.activeTab.toLowerCase()
        this.routerPush({name: 'EmailOpen', params: {tab: tabName, dialog: thread.id}})
      }
      this.activeThreadIndex = index
      this.activeThread = thread
    },
    async getMessageInfo (thread) {
      const { threadId = '' } = thread
      const body = {
        header: this.headerGmail(),
        threadId
      }
      this.loaderRun = true
      try {
        const { data } = await GmailApi.getThread(body)
        const { messages = [] } = data
        this.activeEmail = thread
        const labelIds = messages.reduce((acc, msg) => {
          return acc.concat(msg.labelIds)
        }, [])
        set(this.activeEmail, 'labelIds', labelIds)
        const { msg = [] } = this.activeEmail
        this.activeEmail.msg = msg
        this.activeEmail.messages = messages
        this.activeEmail.messages = await this.createBodyMessage(messages)
        this.loaderRun = false
      } catch (err) {
        this.loaderRun = false
        console.error(err)
      }
    },
    createBodyMessage (messages) {
      const thread = this.activeEmail
      const newItems = messages.map((msg, index) => {
        msg.info = this.getInfoMail(thread, index)
        return msg
      })
      return newItems
    },
    batchModify () {
    },
    modifyLabels (item) {
      const { type, threadId, thread } = item
      if (type === 'moveToInbox') {
        this.moveToUnTrash(threadId)
      } else if (type === 'setUnread') {
        this.setUnread(thread)
      } else if (type === 'removeUnread') {
        this.setRead(thread)
      }
    },
    async setUnread ({threadId, labelIds}) {
      const header = this.headerGmail()
      const body = {
        labels: [...labelIds, 'UNREAD']
      }
      const currentElement = this.getStoreEmail(this.type).find((el) => el.id === threadId)
      currentElement.unread = true
      currentElement.labels = body
      try {
        await GmailApi.unReadLetter(threadId, header, body)
      } catch (err) {
        console.error(err)
      }
    },
    async setRead ({threadId, labelIds}) {
      const header = this.headerGmail()
      const body = {
        labels: ['UNREAD']
      }
      const currentElement = this.getStoreEmail(this.type).find((el) => el.id === threadId)
      currentElement.unread = false
      currentElement.labels = labelIds.filter((el) => el !== 'UNREAD')
      try {
        await GmailApi.readLetter(threadId, header, body)
      } catch (err) {
        console.error(err)
      }
    },
    async moveToUnTrash (threadId) {
      const index = this.getStoreEmail(this.type).findIndex((el) => el.id === threadId)
      this.getStoreEmail(this.type).splice(index, 1)
      const body = this.headerGmail()
      try {
        await GmailApi.moveToUnTrash(threadId, body)
      } catch (err) {
        console.error(err)
      }
    },
    async moveToTrash (threadId) {
      const body = this.headerGmail()
      try {
        await GmailApi.moveToTrash(threadId, body)
      } catch (err) {
        console.error(err)
      }
    },
    toTrash ({ threadId }) {
      const { threadId: threadIdEmail } = this.activeEmail
      const id = threadId || threadIdEmail
      const items = this.getStoreEmail(this.type)
      const index = items.findIndex((el) => el.id === id)
      this.getStoreEmail(this.type).splice(index, 1)
      this.moveToTrash(id)
      if (threadIdEmail) this.checkedDeletedThread(id)
      this.$emit('updateCounter')
      this.calcPositionThrottle()
      this.checkedMails = []
    },
    capitalize (str) {
      return str.replace(/(^|\s)\S/g, (a) => a.toUpperCase())
    },
    getAddress (from) {
      const email = trim(from.match(/<.+>/gi)).replace(/(^<)|(>$)/gi, '')
      const name = trim(from.match(/.+\s/gi)) || from
      return {
        name: this.capitalize(name) || '',
        email: email || from
      }
    },
    createFrom (headers) {
      const { username = 'founder founder', email = 'k.syndikat@gmail.con' } = this.activeUser
      const from = headers.find((s) => s.name === 'From')
      switch (this.type) {
      case SENT:
        return {name: this.capitalize(username), email}
      case DRAFT:
        return {name: this.capitalize(username), email}
      case INBOX:
        return this.getAddress(from.value)
      case TRASH:
        return this.getAddress(from.value)
      default:
        return ''
      }
    },
    userImage () {
      const path = get(this.activeUser, 'image.path', '')
      switch (this.type) {
      case SENT:
        return path
      case DRAFT:
        return path
      default:
        return ''
      }
    },
    createLetters (letters) {
      const newItems = letters.map((el) => {
        const { headers = [], id, snippet, threadId, labelIds = [] } = el
        const subject = headers.find((s) => s.name === 'Subject')
        const date = headers.find((s) => s.name === 'Date')
        const to = headers.find((s) => s.name === 'To')
        const bcc = headers.find((s) => s.name === 'Bcc')

        return {
          id,
          threadId,
          snippet,
          userImage: this.userImage(),
          from: this.createFrom(headers),
          to: to ? this.getAddress(to.value) : '',
          bcc: bcc ? this.getAddress(bcc.value) : '',
          subject: subject ? subject.value : undefined,
          date: date.value,
          labelIds,
          unread: this.type === INBOX ? labelIds.some((el) => el === 'UNREAD') : undefined
        }
      })
      return newItems
    },
    onScrollToBottom () {
      this.gmailActions()
    },
    onScroll () {
    },
    async gmailActions () {
      if (this.nextPageToken === undefined) return
      const header = this.headerGmail()
      const body = {
        header,
        labelIds: this.type,
        nextPageToken: this.nextPageToken
      }
      try {
        const { data } = await GmailApi.gmailActions(body)
        const { letters = [], nextPageToken = '' } = data
        this.nextPageToken = nextPageToken || undefined
        const newItems = this.createLetters(letters)
        this.getStoreEmail(this.type).push(...newItems)
      } catch (err) {
        console.error(err)
      }
    }
  },
  watch: {
    updateThreadStore (threadId) {
      if (!threadId) return
      this.updateThread(threadId)
    },
    filterByTag (newVal, oldVal) {
      if (newVal.id === oldVal.id) return
      const userId = get(this.activeUser, 'gmail.email', '')
      if (newVal.id) this.getUserEmails({userId})
    },
    searchStore (newVal) {
      this.scrollUp()
      this.activeThreadIndex = false
      this.activeThread = false
      this.searchInGmail = newVal.keywordGmail
      // if (!newVal.keywordGmail) {
      //   this.runBackgroundLoadingThreads({label: this.type})
      //   this.checkUpdateThread()
      //   return
      // }
      // this.getThreadsList({userId: this.userId, label: this.type})
    },
    newMessage (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal.status === 'open') {
        const id = get(this.newMessage, 'send.threadId', '')
        this.checkActiveThread(id)
      }
    },
    activeUser (newVal, oldVal) {
      const { email } = this.activeUser
      if (email) this.gmailActions()
      const userId = get(this.activeUser, 'gmail.email', '')
      const oldUserId = get(oldVal, 'gmail.email', '')
      const newUserId = get(newVal, 'gmail.email', '')
    },
    activeEmail: {
      deep: true,
      handler (newVal, oldVal) {
        const oldListLength = this.listEmails.length
        const isLabels = this.type === this.typeCases.SAVED || this.type === this.typeCases.TODO
        if (isLabels) {
          this.listEmails = filter(this.listEmails, mail => {
            const labelIds = get(mail, 'labelIds', [])
            return labelIds.includes(this.type)
          })
        }
        if (isLabels && oldListLength > this.listEmails.length) this.removeActiveThread()
        if (!this.listEmails.length) this.activeTab = sidebarTabs[0].id
        if (newVal === oldVal) return
        if (newVal.delete) this.toTrash({})
        if (isEmpty(newVal)) {
          this.activeThread = false
          this.activeThreadIndex = false
        }
      }
    },
    type () {
      const { email } = this.activeUser
      if (email) this.gmailActions()
      this.searchInGmail = ''
      this.searchList = []
      this.scrollUp()
    }
  },
  beforeMount () {
    const { email } = this.activeUser

    const getEmails = async () => {
      this.loaderRun = true;
      await this.gmailActions();
      this.loaderRun = false;
    }

    if (email) getEmails();
  },
  mounted () {
    this.setContainerHeight()
    window.addEventListener('resize', this.setContainerHeight, false)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setContainerHeight, false)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-list {
    @include global-font;
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 100%;
    min-height: 100%;

    &_background {
      background-color: $color-white;
      height: 100%;
    }

    &-header {
      position: relative;
      display: flex;
      align-items: center;
      padding: 20px 22px 21px 18px;
      background-color: $color-white;

      &:after {
        @include line-after-bot;
      }

      &-sort {
        display: flex;
        align-items: center;
        justify-content: center;
        color: $color-accent;
        margin-left: 18px;
        transition: 0.3s;
        cursor: pointer;
        user-select: none;

        &:hover {
          color: $color-accent-hover;
        }

        &__text {
          font-weight: 600;
          font-size: 12px;
          line-height: 14px;
          text-decoration-line: underline;
        }

        &__icon {
          font-size: 8px;
          margin-left: 2px;
          transition: 0.3s;

          &_active {
            transform: rotate(180deg);
          }
        }
      }

      &-checked {
        display: flex;
        align-items: flex-end;
        cursor: pointer;
        user-select: none;

        &__count {
          display: block;
          margin-left: 14px;
          color: $color-silver-chalice;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
        }

        &__length {
          //position: absolute;
          pointer-events: none;
          //opacity: 0;
        }
      }
    }

    &-body {
      display: flex;
      flex-direction: column;
      position: relative;
      padding-right: 15px;
      margin-right: -15px;
      transition: .5s;
      width: calc(100% + 15px);

      &_center {
        display: grid;
        justify-content: center;
        align-items: center;
        height: 100%;
        grid-template-rows: 14px 1fr;
      }

      &_hide {
        opacity: 0.5;
      }

      &:after {
        content: '';
        width: 100%;
        height: 100%;
        background-color: $color-white;
      }

      &__shadow {
        min-height: 14px;
        background-color: $color-white;

        &_radius {
          border-radius: 0 0 15px 0;
        }
      }

      &__sign-in {
        width: 165px;
        margin: 0 auto;
      }

      &__error {
        position: relative;
        padding: 20px;
        text-align: center;
      }

      //&__hide-elements {
      //  height: 0;
      //}

      &__end-list {
        position: relative;
        height: 19px;
        background-color: $color-white;

        &:after {
          @include line-after-top;
        }
      }

      &__loader {
        width: 100%;
        display: flex;
        position: relative;
        transition: .3s;
        background-color: $color-white;
        min-height: 123px;
        z-index: 1;
      }
    }
  }

  .bbe-list-body-virtual {
    overflow-y: auto;
    height: calc(100vh - 210px);
  }

</style>

<style lang="scss">
  @import "../../../sass/variables";

  .bbe-list {
    .ps__rail-y.ps--clicking .ps__thumb-y, .ps__rail-y:focus > .ps__thumb-y,
    .ps__rail-y:hover > .ps__thumb-y,
    .ps .ps__thumb-y {
      width: 5px;
      background-color: $color-accent;
      z-index: 3;
      right: 10px;
    }

    .ps__thumb-y {
      left: 0;
    }

    .ps .ps__rail-y {
      background-color: transparent;
    }

    &-list-body-thread-main-user-top-info-tags {
      .ps__rail-x,
      .ps__rail-y,
      .ps__thumb-x,
      .ps__thumb-y {
        display: none !important;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Email/EmailList/EmailList.vue